const state = {
  auth: []
}

const mutations = {
  SAVE_AUTH: (state, payload) => {
    state.auth = payload
  }
}

export default {
  namespaced: true,
  state,
  mutations
}